(function(angular) {
    'use strict';

    var app = angular.module('asDemandMgr');

    app.service('InterscrollerCommonService', [
        '$http',
        '$q',
        function($http, $q) {
            this.replaceCommonInterscrollerPlaceholders = function(scope, template, options) {
                template = template.replace('[user_fireImpressionUrlPercent]', options.minVisbilityThreshold);
                template = template.replace('[user_showCloseCounter]', options.showCloseCounter);
                template = template.replace('[user_hardcodedClickout]', options.hardcodedClickout);
                template = template.replace('[user_closeCounter]', options.closeCounter);
                template = template.replace('[user_closeActionTime]', options.closeActionTime);
                template = template.replace('[user_customCss]', options.customCss);
                template = template.replace('[user_maxWidth]', options.maxWidth);
                template = template.replace('[user_borderHeight]', options.borderHeight);
                template = template.replace('[user_backgroundColorBorder]', options.borderBackgroundColor);
                template = template.replace('[user_textLabelText]', options.textLabelText);
                template = template.replace('[user_fontSize]', options.fontSize);
                template = template.replace('[user_backgroundColor]', options.backgroundColor);
                template = template.replace('[user_textLabelColor]', options.textLabelColor);
                template = template.replace('[user_insertionId]', options.insertionId);
                template = template.replace('[user_creativeUrl]', scope.creative.amediaUrl != null ? scope.creative.amediaUrl : '');
                template = template.replace('[user_creativeWidth]', options.creativeWidth);
                template = template.replace('[user_creativeHeight]', options.creativeHeight);
                template = template.replace('[user_insertionCustomHtml]', scope.addslashes(options.insertionCustomHtml));
                template = template.replace('[user_agencyHtml]', scope.addslashes(options.agencyHtml));
                return template;
            };

            this.replaceInterscrollerBPlaceholders = function(scope, template, options) {
                template = template.replace('[user_closeStickyTime]', options.closeStickyTime);
                return template;
            };

        },
    ]);
})(window.angular);
